import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TextField,
  Button,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CopyUrlButton from "./CopyUrlButton";

const SearchForm = ({
  triggerUserSearch,
  triggerCurrentAssignment,
  resultLoading,
  configuration,
}) => {
  const [activeAssignment, setActiveAssignment] = useState(true);
  const [activeUserSearch, setActiveUserSearch] = useState(false);
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    skip: 0,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      skip: 0,
    });
  };

  const handleCurrentAssignments = () => {
    triggerCurrentAssignment(true);
    setActiveAssignment(true);
    setActiveUserSearch(false);
  };

  const handleUserSearch = () => {
    triggerUserSearch(formData);
    setActiveUserSearch(true);
    setActiveAssignment(false);
  };

  return (
    <Box sx={{ padding: 3, background: "#F0F0F0" }}>
      <Grid container spacing={2}>
        {configuration?.UserSearch?.allowedUserSearchQueryFields.length > 0 ? (
          configuration?.UserSearch?.allowedUserSearchQueryFields?.map(
            (field, key) => {
              return (
                <Grid item size={{ xs: 12, md: 4, lg: 4 }} key={key}>
                  <TextField
                    fullWidth
                    label={t(`searchForm.${field}`)}
                    variant="outlined"
                    name={field}
                    value={formData.field}
                    onChange={handleInputChange}
                  />
                </Grid>
              );
            }
          )
        ) : (
          <Typography variant="body1" sx={{ display: "block" }}>
            {t("searchForm.configurationError")}
          </Typography>
        )}
        {configuration?.UserSearch?.allowedUserSearchQueryFields.length > 0 && (
          <>
            <Grid item size={{ xs: 12, md: 3, lg: 2 }}>
              <Button
                variant={activeAssignment ? "contained" : "outlined"}
                onClick={handleCurrentAssignments}
                sx={{
                  height: "100%",
                  fontWeight: "bold",
                  color: "primary",
                  backgroundColor: activeAssignment ? "primary.dark" : "none",
                }}
                fullWidth
              >
                {t("searchForm.currentAssignments")}
              </Button>
            </Grid>
            <Grid item size={{ xs: 12, md: 3, lg: 2 }}>
              <Button
                variant={activeUserSearch ? "contained" : "outlined"}
                color="primary"
                onClick={handleUserSearch}
                sx={{
                  height: "100%",
                  fontWeight: "bold",
                  backgroundColor: activeUserSearch ? "primary.dark" : "none",
                }}
                fullWidth
                disabled={resultLoading ? true : false}
              >
                {resultLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  t("searchForm.findUser")
                )}
              </Button>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 2.2 }}>
              <CopyUrlButton />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default SearchForm;
